<!--
 * @Author: Belief liang.huang@rockynet.onaliyun.com
 * @Date: 2025-11-04 16:55:53
 * @LastEditors: Belief liang.huang@rockynet.onaliyun.com
 * @LastEditTime: 2025-11-13 14:34:11
 * @FilePath: /mall-wap-vue/src/divs/mine/question/detail/components/AboutPlatform.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="question">
    <div class="item item_title">Milky Cloud</div>
    <div class="item item_title">连接全球好品牌，与广大消费者共享美好生活</div>

    <div class="item item_title section_bg">品牌定位</div>
    <div class="item">
      Milky Cloud是一站式智慧零售平台，专注将澳新及全球优质品牌与广大消费者紧密相连。我们不仅是跨境购物平台，更是品质生活的桥梁。
    </div>

    <div class="item item_title section_bg">使命愿景</div>
    <div class="item">我们相信：</div>
    <div class="item item_title flex-center">
      <div class="blue_dot">·</div>
      <div>每一份优质营养都值得被传递</div>
    </div>
    <div class="item item_title flex-center">
      <div class="blue_dot">·</div>
      <div>每一次消费体验都应充满温度</div>
    </div>
    <div class="item">
      Milky Cloud致力于让更多消费者足不出户即可轻松触达全球精选产品，享受健康、便捷与美好的生活方式。
    </div>

    <div class="item item_title section_bg">平台价值</div>
    <div class="item item_title flex-center">
      <div class="blue_dot">·</div>
      <div class="item_title">
        全球精选：<span class="normal"
          >澳新起步，延展至全球，严选优质品牌。</span
        >
      </div>
    </div>
    <div class="item item_title flex-center">
      <div class="blue_dot">·</div>
      <div class="item_title">
        责任担当：<span class="normal"
          >不仅销售产品，更有使命推荐值得信赖的好品牌。</span
        >
      </div>
    </div>
    <div class="item item_title flex-center">
      <div class="blue_dot">·</div>
      <div class="item_title">
        安心体验：<span class="normal"
          >承诺“海外正品保障，海外直供”，让每一位用户放心购买。</span
        >
      </div>
    </div>
    <div class="item item_title flex-center">
      <div class="blue_dot">·</div>
      <div class="item_title">
        智慧零售：<span class="normal"
          >通过科技赋能，创造便捷、舒心、省心的跨境购物体验。</span
        >
      </div>
    </div>

    <div class="item item_title section_bg">品牌承诺</div>
    <div class="item">
      Milky Cloud承诺，所有商品均为
      <span class="item_title">海外正品直供</span
      >，我们为您甄选世界好物，只为让每一位用户拥有更优质的生活、更安心的体验。
    </div>

    <!-- <div class="item item_index">
      {{
        $G(
          "Milky Cloud--为澳洲及全球消费者提供更多放心、优质、舒心的母婴产品、美妆个护、食品保健等类目。"
        )
      }}
      <span class="item_title"
        >关键词：澳新购、价值创造者、定义优质生活体验</span
      >
    </div>
    <div class="item item_index item_top">
      {{
        $G(
          "Milky Cloud希望通过这个平台让更多的消费者接触到澳新乃至整个全球最优秀的产品，足不出户即可购买到丰富优质的产品。"
        )
      }}
    </div>
    <div class="item item_index">
      同时，<span class="item_title">{{
        $G(
          ">Milky Cloud做一个负责任、有担当的平台，有使命把更多的好品牌和产品推荐出去。"
        )
      }}</span>
    </div>
    <div class="item item_index">
      {{
        $G(
          "Milky Cloud是希望通过这个平台去创造一种价值：可以让所有使用Milky Cloud的用户都可以有更优质的生活，更放心、舒心的体验。"
        )
      }}
    </div>
    <div class="item item_index">
      {{ $G("Milky Cloud承诺其销售的所有商品是")
      }}<span class="item_title">“海外正品保障，海外直供”</span
      >，为您创造一个便捷的跨境购物体验，足不出户轻松扫遍澳新，让您省心更放心！
    </div> -->
  </div>
</template>

<script>
export default {
  methods: {
    backClick() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.question {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
  padding: 15px;
  border-top: 1px solid #eee;
}
.item {
  margin-top: 10px;
}
.item_index {
  span-indent: 25px;
}
.item_title {
  font-size: 14px;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
}
.item_top {
  margin-top: 30px;
}
.go {
  color: #2976e8;
}

.section_bg {
  width: 100%;
  background-color: #fff6eb;
}

.blue_dot {
  font-size: 30px;
  color: #2976e8;
  margin-right: 9px;
}

.flex-center {
  display: flex;
  justify-content: start;
  align-items: start;
}

.normal {
  font-weight: 400;
}
</style>
